import { createContext } from 'react';
import { NonAdminDashboardFilters } from '../../types';

type NonAdminDashboardContextType = {
  filters: NonAdminDashboardFilters;
  handleFilterChange: (filters: Partial<NonAdminDashboardFilters>) => void;
};

export const NonAdminDashboardContext =
  createContext<NonAdminDashboardContextType | null>(null);
